import React from "react";
import styles from "../../styles/Credits.module.scss";

function Credits() {
  return <div className={styles.container}> Credits </div>;
}

export default Credits;
